export class LRU<K, V> {
	cache = new Map<K, V>()
	max: number
	evictionCallback: (_: V) => void

	constructor(max = 10, evictionCallback: (_: V) => void = (_) => {}) {
		this.max = max
		this.evictionCallback = evictionCallback
	}

	has(key: K) {
		return this.cache.has(key)
	}

	get(key: K) {
		const item = this.cache.get(key)

		if (item) {
			// refresh key
			this.cache.delete(key)
			this.cache.set(key, item)
		}

		return item
	}

	set(key: K, val: V) {
		if (this.cache.has(key)) {
			// refresh key
			this.cache.delete(key)
		} else if (this.cache.size == this.max) {
			// evict oldest
			const oldestKey = this.first()
			if (oldestKey === undefined) {
				return this.cache.set(key, val)
			}

			const oldest = this.cache.get(oldestKey)

			if (oldest) {
				this.evictionCallback(oldest)
			}

			this.cache.delete(oldestKey)
		}

		this.cache.set(key, val)
	}

	first(): K | undefined {
		return this.cache.keys().next().value
	}
}
